export default __webpack_public_path__ + "img/foundation_logo.d67a70.png";